import { gql } from "@apollo/client";

const UPDATE_CONNECTION = gql`
  mutation UpdateConnection($input: UpdateConnectionInput!) {
    updateConnection(input: $input) {
      connection {
        id
        enabled
      }
    }
  }
`;

const REMOVE_CALENDLY_CONNECTION = gql`
  mutation RemoveCalendlyConnection($input: RemoveCalendlyConnectionInput!) {
    removeCalendlyConnection(input: $input) {
      clientMutationId
      id
    }
  }
`;

export { UPDATE_CONNECTION, REMOVE_CALENDLY_CONNECTION };
